export default __webpack_public_path__ + "static/media/kelantan2015B.8bb9ebfb.jpg";